/**
 * Pick Radix DropdownMenuContent `align` (and matching Tailwind for absolute menus)
 * from trigger position: right-half of viewport → `end` (panel grows left); else `start`.
 */
export function computeMenuAlignFromTrigger(triggerEl) {
    if (typeof window === 'undefined' || !triggerEl?.getBoundingClientRect) {
        return 'start';
    }
    const r = triggerEl.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const vw = window.innerWidth;
    if (!vw) return 'start';
    return cx > vw / 2 ? 'end' : 'start';
}

/** Tailwind classes for `absolute top-full` menus (LTR). */
export function absoluteMenuAlignClasses(align) {
    return align === 'end' ? 'right-0 left-auto' : 'left-0 right-auto';
}
